import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { BaseComponent } from '../../../components/BaseComponent';
import { Button } from '../../../components/Buttons';
import { Modal, ModalControls } from '../../../components/Modal';
import { selectInvoice } from '../selectors';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../containers/App/Components/Button/Button';

const STATE = {};

/* eslint-disable react/prefer-stateless-function */
class DeleteInvoiceModalComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  onConfirm() {
    this.props.onConfirm();
  }

  onCancel() {
    this.props.onCancel();
  }

  render() {
    return (
      <ModalComponent onClose={this.reset.bind(this)} title={this.lbl(`invoice.details.deleteModalTitle`)}>
        <div className="d-flex gap-2">
          <ButtonComponent style={'ButtonSoftEdit'} onClick={this.onConfirm.bind(this)} primary>
            {this.lbl('confirm')}
          </ButtonComponent>
          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.onCancel.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }
}

DeleteInvoiceModalComp.propTypes = {};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const DeleteInvoiceModal = compose(withConnect, withRouter)(DeleteInvoiceModalComp);
